import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const cardData = [
  {
    id: 1,
    image: "/images/meal1.jpeg",
    title: "Sappayama",
    modalImages: ["/images/sappayama1.jpeg"]
  },
  {
    id: 2,
    image: "/images/meal5.jpeg",
    title: "Srilankan Kaha Bath",
    modalImages: ["/images/kaha1.jpeg"]
  },
  {
    id: 3,
    image: "/images/meal2.jpeg",
    title: "Chicken Biriyani",
    modalImages: ["/images/biriyani1.jpeg"]
  },
    {
      id: 4,
      image: "/images/meal3.jpeg",
      title: "Chicken Fried Rice",
      modalImages: ["/images/fried1.jpeg"]
    },
      {
        id: 5,
        image: "/images/meal4.jpeg",
        title: "Chicken Kottu",
        modalImages: ["/images/kottu1.jpeg"]
      },
       {
              id: 6,
              image: "/images/meal6.jpeg",
              title: "Bite Kulla",
              modalImages: ["/images/kulla1.jpeg"]
            },
];

const InfoSection = () => {
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleViewMore = (card) => {
    setSelectedCard(card);
    setCurrentIndex(0); // start from first image
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      (prev + 1) % selectedCard.modalImages.length
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      (prev - 1 + selectedCard.modalImages.length) % selectedCard.modalImages.length
    );
  };

  return (
    <div className="info-section">
    {/* Photos */} <div className="cover-photo-container"> <div className="photo-grid"> <img src="/images/meal4.jpeg" className="cover-photo" /> <img src="/images/meal2.jpeg" className="cover-photo" /> <img src="/images/meal5.jpeg" className="cover-photo" /> </div> </div>

      {/* Headings */}
      <h2 className="section-main-heading">
        <strong> Meet the New Stars on </strong> <br/> COCOCLOCO MENU
      </h2>
      <h2 className="section-main-heading2">
        (DELIVERY AND TAKE-AWAY ONLY)<br/> Place Your Order at Least 24 hours in advance
      </h2>

      {/* Button */}
      <div className="package-reservation">
        <button className="reservations-button" onClick={() => navigate('/contact')}>
          <p className="image-gallery1-heading2">Contact us for place your order....</p>
        </button>
      </div>

      {/* 3 Squares */}
      <div className="card-row">
        {cardData.map((card) => (
          <div key={card.id} className="info-card">
            <img src={card.image}  className="card-image" />
            <h3 className="card-title"><strong>{card.title}</strong></h3>
            <button
              className="view-more-btn"
              onClick={() => handleViewMore(card)}
            >
              View More
            </button>
          </div>
        ))}
      </div>

      {/* Modal Overlay */}
      {selectedCard && (
        <div className="modal-overlay" onClick={() => setSelectedCard(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedCard.modalImages[currentIndex]}
              alt={selectedCard.title}
              className="modal-image"
            />

            {/* Navigation Arrows */}
            {/*{selectedCard.modalImages.length > 1 && (
              <>
                <button className="nav-btn left" onClick={handlePrev}>◀</button>
                <button className="nav-btn right" onClick={handleNext}>▶</button>
              </>
            )}*/}

            {/* Close button */}
            <button className="close-btn" onClick={() => setSelectedCard(null)}>X</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default InfoSection;
